import { element } from 'angular';
export var CompareListOnHoverDirective = [
    'compareChannel',
    '$compile',
    '$rootScope',
    '$timeout',
    'compareListEvents',
    function (compareChannel, $compile, $rootScope, $timeout, compareListEvents) {
        return {
            link: function ($scope, $element) {
                var compareListElementScope;
                var removeCompareListIfOutOfElement = function (event) {
                    var $relatedTarget = element(event.relatedTarget);
                    var $container = element('.master__container');
                    if ($relatedTarget.length > 0 && $relatedTarget.closest('compare-list').length > 0) {
                        return;
                    }
                    element('compare-list', $container).remove();
                    if (compareListElementScope) {
                        compareListElementScope.$destroy();
                    }
                };
                $element.on('click', function (ev) {
                    removeCompareListIfOutOfElement(ev);
                    $element.trigger('mouseenter');
                });
                $element.on('mouseenter', function () {
                    var $container = element('.master__container');
                    element('compare-list', $container).remove();
                    compareListEvents.cancelTimeouts();
                    if (compareChannel.get().length === 0) {
                        return;
                    }
                    compareListElementScope = $rootScope.$new();
                    $compile('<compare-list class="p-3" ng-style="compareListStyles" compare-list-events></compare-list>')(compareListElementScope, function ($compiled, $compiledScope) {
                        $container.append($compiled);
                        $timeout(function () {
                            var elementOffset = $element.offset();
                            $compiledScope.compareListStyles = {
                                left: elementOffset.left + $element.width() - $compiled.outerWidth() + 'px',
                                top: elementOffset.top -
                                    $element.height() / 2 -
                                    element('.master__container').offset().top -
                                    $compiled.outerHeight(true) +
                                    'px',
                            };
                        });
                    });
                });
                $element.on('mouseout', function (event) {
                    compareListEvents.registerTimeout(function () {
                        removeCompareListIfOutOfElement(event);
                    });
                });
                $scope.$on('$destroy', function () {
                    var $container = element('.master__container');
                    element('compare-list', $container).remove();
                    if (compareListElementScope) {
                        compareListElementScope.$destroy();
                    }
                    compareListEvents.cancelTimeouts();
                    $element.off('click mouseenter mouseout');
                });
            },
            restrict: 'A',
        };
    },
];
